export default __webpack_public_path__ + "static/media/team4.6a71ce41.jpg";